import React, { Component } from 'react';  // eslint-disable-line no-unused-vars
import CourseShell from './Course/CourseShell.js';
import TutorialShell from './Tutorial/TutorialShell.js';
import { connect } from 'react-redux';
import * as actions from '../actions';
import Home from './Home/Home.js';
import Catalog from './Catalog/Catalog.js';
import Poet from './Poet/Poet.js';
import ScrollToTop from './ScrollToTop.js';
import Page404 from './Page404.js';
import { Router, Route, Redirect, Switch } from 'react-router-dom';
import history from '../helpers/history';



function LessonRouter(props){
  const routes = [
    { path: '/poet/:poet/',
      component: Poet
    },
    {
      path: '/catalog/courses',
      component: Catalog
    },
    {
      path: '/',
      component: Home
    }
  ];

  return (
    <Router history={history}>
      <ScrollToTop>
        <div>
          <Switch>
            <Route exact path="/:poet/:poem/lesson/:id" render={(params) => {
              // if(!props.home.user && !props.loggedIn){
              //   return <Redirect to="/" />
              // }
              if(params.match.params.poem === 'tutorial'){
                return <TutorialShell {...params} />
              }
              else {
                return <CourseShell {...params} />
              }
            }}/>
            {routes.map((route, index) => (
              <Route
                key={index}
                exact
                path={route.path}
                component={route.component}
              />
            ))}
            <Route component={Page404}/>
          </Switch>
        </div>
      </ScrollToTop>
    </Router>
  )
}

function mapStateToProps(state) {
  return {
    home: state.home
  };
}

export default connect(mapStateToProps, actions)(LessonRouter);



// WEBPACK FOOTER //
// ./src/components/LessonRouter.js